import Rellax from "Rellax"

const ISMOBILE = window.matchMedia("only screen and (max-width: 768px)").matches

if(!ISMOBILE){
  new Rellax('.rellax', {
    speed: -2,
    center: true,
  });
}
